<template>
    <div class="text-muted">
        <b-row>
            <b-col>
                <p class="mb-1 text-uppercase">
                    <small>
                        <i class="icon-speedometer"></i>
                        {{ $t('ranges.ranges') }}
                    </small>
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-button
                    id="btn-target-see-ranges"
                    v-b-toggle.ranges
                    variant="primary"
                    type="button"
                    class="float-right btn btn-ghost-primary btn-pill btn-sm"
                >
                    {{ $t('ranges.seeRanges') }}
                </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-collapse id="ranges">
                    <div v-if="ranges.length">
                        <div
                            class="list-group-item-accent-light text-justify rounded mb-3 p-0"
                            v-for="range in ranges"
                            :key="range.id"
                        >
                            <div class="ml-2">
                                <div>
                                    <small
                                        ><strong>
                                            {{ range.title }}
                                        </strong></small
                                    >
                                </div>
                                <div>
                                    <small
                                        ><strong>
                                            {{ formatNumber(range.value) }}
                                        </strong></small
                                    >
                                </div>
                                <div>
                                    <small> {{ range.description }} </small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-center mt-2 mx-3">
                        <b-alert show class="pt-1 pb-1">
                            <small>{{
                                indicatorType == 'kpi'
                                    ? $t('ranges.kpiWithoutRangesRegistered')
                                    : $t('ranges.targetWithoutRangesRegistered')
                            }}</small>
                        </b-alert>
                    </div>
                </b-collapse>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { formatNumber } from '@/lib/utils'

export default {
    name: 'CRanges',
    props: ['ranges', 'indicatorType'],
    methods: {
        formatNumber(number) {
            return formatNumber(number)
        },
    },
}
</script>
